import { useState, useEffect, memo, useRef } from "react";
import axios from "../../customAxios.js";
import { Button, Box, Stack, Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WebhookItem from "./WebhookItem.jsx";
import WebhookForm from "./WebhookForm.jsx";

const WebhookMain = () => {
  const [webhooks, setWebhooks] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedWebhook, setSelectedWebhook] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [snackAlert, setSnackAlert] = useState({ active: false, message: "" });
  const handleSnack = (active, message) => {
    setSnackAlert({ active, message });
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackAlert({ active: false, message: "" });
  };

  const toggleDrawer = (drawerOpen) => () => {
    setDrawerOpen(drawerOpen);
    setSelectedWebhook(null);
    setIsEditing(false);
  };

  const showDrawer = (event) => {
    event.preventDefault();
    setDrawerOpen(true);
  };

  const effectRun = useRef(false);
  useEffect(() => {
    if (effectRun.current) return;

    const fetchSettingWebhooks = async () => {
      try {
        const { data } = await axios.get("companies/setting_webhooks/");
        setWebhooks(data);
      } catch (error) {
        handleSnack(
          true,
          error?.response?.data?.error ||
            "Error al obtener obtener los datos de webhooks"
        );
        console.error(`Fallo al obtener webhooks: ${error?.response || error}`);
      }
    };
    fetchSettingWebhooks();
    effectRun.current = true;
  }, []);

  return (
    <>
      <Box sx={{ width: "100%", maxWidth: 600, bgcolor: "background.paper" }}>
        <Stack
          spacing={{ xs: 1, sm: 2, md: 4 }}
          direction={{ xs: "column", sm: "row-reverse" }}
          sx={{ mr: "42px", justifyContent: "space-between" }}
        >
          <Button variant="outlined" size="small" onClick={showDrawer}>
            Agregar
          </Button>
        </Stack>
        {webhooks.map((webhook) => (
          <WebhookItem
            key={`webhook-item-${webhook.id}`}
            webhook={webhook}
            handleSnack={handleSnack}
            setSelectedWebhook={setSelectedWebhook}
            showDrawer={showDrawer}
            setIsEditing={setIsEditing}
            setWebhooks={setWebhooks}
          />
        ))}
      </Box>
      <WebhookForm
        selectedWebhook={selectedWebhook}
        handleSnack={handleSnack}
        drawerOpen={drawerOpen}
        toggleDrawer={toggleDrawer}
        isEditing={isEditing}
        setWebhooks={setWebhooks}
      />

      <Snackbar
        open={snackAlert.active}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        message={snackAlert.message}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleSnackClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </>
  );
};

export default memo(WebhookMain);
